import React from "react";
import Container from "react-bootstrap/Container";
import {Alert, Breadcrumb, Col, Row, Table} from "react-bootstrap";
// import {Link} from "react-router-dom";
import PFDateAndDesc from "../common/pfDateAndDesc";
import PFFinaleWithImage from "../common/pfFinaleWithImage";


const CurrentPF = () => {

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <h3>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Porchfest 2026</Breadcrumb.Item>
                            </Breadcrumb>
                        </h3>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <Alert variant="success">
                            <PFDateAndDesc/>
                        </Alert>

                        {/*<h4>&#10024;&nbsp;What's New This Year</h4>*/}
                        {/*<p>*/}
                        {/*    This year's Porchfest will use the same registration process as last year.*/}
                        {/*</p>*/}
                        {/*<ul>*/}
                        {/*    <li>If you registered last year, you do not need to re-register this year. However, you*/}
                        {/*        will need to add your act or venue since those are not carried over from last*/}
                        {/*        year.</li>*/}
                        {/*    <li>If you don't remember your password, you can use*/}
                        {/*        the <Link to="/forgotpass" reloadDocument="true">forgot password</Link> page to*/}
                        {/*        create a new one.</li>*/}
                        {/*    <li>This year's time slots are one-hour slots with no break time in between. See*/}
                        {/*        our <Link to="/faq" reloadDocument="true">FAQ</Link> page for more details.</li>*/}
                        {/*</ul>*/}
                        <br/>

                        <div className="mb-3">
                            <PFFinaleWithImage/>
                        </div>

                        <h4>&#128204;&nbsp;Important Dates</h4>
                        <Table bordered hover size="lg" responsive>
                            <tbody>
                            <tr>
                                <td width="50%">Registration of hosts and performers begins</td>
                                <td>March 1, 2026</td>
                            </tr>
                            <tr>
                                <td>Registration closes</td>
                                <td>May 31, 2026</td>
                            </tr>
                            <tr>
                                <td>Final Porchfest schedule published</td>
                                <td>June 7, 2026</td>
                            </tr>
                            <tr>
                                <td>Rain date announced (if necessary)</td>
                                <td>June 12, 2026</td>
                            </tr>
                            </tbody>
                        </Table>
                        <br/>

                        {/*<h4>&#127775;&nbsp;Get Involved</h4>*/}
                        {/*<ul>*/}
                        {/*    <li><Link to="/register" reloadDocument="true">Register</Link> as a host or performer*/}
                        {/*        and manage your acts and venues on our site</li>*/}
                        {/*    <li>Browse <Link to="/acts" reloadDocument="true">acts</Link> and <Link to="/venues"*/}
                        {/*        reloadDocument="true">venues</Link> as they get added for an up-to-date view of*/}
                        {/*        the event</li>*/}
                        {/*    <li>Have questions? Check out our <Link to="/faq" reloadDocument="true">FAQ</Link></li>*/}
                        {/*</ul>*/}
                        {/*<p>*/}
                        {/*    Winchester Porchfest 2026 is going to be a great day — we can't wait to see you there!*/}
                        {/*</p>*/}

                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default CurrentPF;
